/** "Device w/ Customer" — shown wherever a released job appears. */

import React from 'react';
import { Chip, Tooltip } from '@mui/material';

import type { WorkItem } from '../workItemTypes';
import { deviceReleaseSummary } from '../../../utils/deviceRelease';

export const DeviceWithCustomerChip: React.FC<{ workItem: WorkItem; size?: 'small' | 'medium' }> = ({
  workItem,
  size = 'small',
}) => {
  if (!workItem.deviceWithCustomer) return null;
  return (
    <Tooltip title={deviceReleaseSummary(workItem)}>
      <Chip label="Device w/ Customer" color="warning" size={size} variant="outlined" />
    </Tooltip>
  );
};
